// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"293":"39e15a4a","805":"c9796dfc","880":"e6045810"}[chunkId] + ".chunk.css";
};